// state
const state = {
  loading: false,
  seq : '',
  maxSeq : '',
  corpNo : '',
  cusId  : '',
  lginChk : false,
  lginAuth : '',
  exChange : '',
  loginTypeCd :'',
}

// mutations
const mutations = {
  changeLoadingFlag(state, flag) {
    state.loading = flag
  },
  commitSeq(state, flag) {
    state.seq = flag
  },
  maxSeq(state, flag) {
    state.maxSeq = flag
  },
  commitCorpNo(state, flag) {
    state.corpNo = flag
  },
  commitsType(state, flag) {
    state.sType = flag
  },
  commitCusId(state, flag) {
    state.cusId = flag
  },
  chgLginChk(state, flag) {
    state.lginChk = flag
  },
  lginAuthChk(state, flag) {
    state.lginAuth = flag
  },
  exChangeChk(state, flag) {
    state.exChange = flag
  },
  loginIdChk(state, flag){
    state.login_id = flag
  },
  bizNoChk(state, flag){
    state.biz_no = flag
  },
  corpNoEncChk(state, flag){
    state.corp_no_enc = flag
  },
  corpNmKr(state, flag){
    state.n_ctorkr = flag
  },
  corpNmEn(state, flag){
    state.n_ctoren = flag
  },
  gita(state, flag){
    state.gita = flag
  },
  loginTypeCdChk(state, flag){
    state.loginTypeCd = flag
  }
}

// actions
const actions = {
  callMutation: _.debounce(({ state, commit }, { flag }) => {
    commit('changeLoadingFlag', flag)
  }, 0),
}

// getters
const getters = {
  isLoading(state) {
    return state.loading
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
